import { createRegionsClient } from '@pay-roadrunner/regions-ui';
import { createTaxConfigurationClient, TaxConfigurationScreen } from '@pay-roadrunner/tax-configuration-ui';
import { authFetch } from '../auth/authFetch';
import { getApiBaseUrl } from '../auth/api';
import { TabbedItemPage } from './TabbedItemPage';

const apiClientDeps = { getBaseUrl: getApiBaseUrl, fetchImpl: authFetch };
const regionsClient = createRegionsClient(apiClientDeps);
const taxConfigurationClient = createTaxConfigurationClient(apiClientDeps);

export const ConfigurationPage = () => (
  <TabbedItemPage
    itemPath="/maintenance/configuration"
    tabContentOverrides={{
      tax: <TaxConfigurationScreen regionsClient={regionsClient} taxConfigurationClient={taxConfigurationClient} />,
    }}
  />
);
